import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {PRICES_HUB_ANALYTICS_LOCATION} from "./prices_hub_analytics";

interface ITrackPricesHubOffersFiltersAppliedParams {
    /** City filter label exactly as the user sees it, including Wszystkie. */
    city: string;
}

export const trackPricesHubOffersFiltersApplied = (params: ITrackPricesHubOffersFiltersAppliedParams) => {
    trackAmplitudeEvent("listing_filters_applied", {
        filter_trigger: "manual",
        location: PRICES_HUB_ANALYTICS_LOCATION,
        city: params.city
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {PRICES_HUB_ANALYTICS_LOCATION} from "./prices_hub_analytics";

interface ITrackPricesHubOffersFiltersAppliedParams {
    /** City filter label exactly as the user sees it, including Wszystkie. */
    city: string;
}

export const trackPricesHubOffersFiltersApplied = (params: ITrackPricesHubOffersFiltersAppliedParams) => {
    trackAmplitudeEvent("listing_filters_applied", {
        filter_trigger: "manual",
        location: PRICES_HUB_ANALYTICS_LOCATION,
        city: params.city
    });
};
